import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  closeLoaderWithMessage,
  openLoaderWithMessage,
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { makeApiCall } from "../../helpers/postRequest";
import {
  IAIProjectDocument,
  IProject,
  IProjectSummary,
  ITempProject,
} from "./aiProjects.types";
import { api } from "../../api/api";
import { action } from "typesafe-actions";
import { ERROR_MESSAGES } from "../../constants/enums";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const getExcelColumnMappingWithAIForProjectsAsync =
  (
    data: any,
    onCallback: (isSuccess: boolean, data?: any) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(openLoaderWithMessage("Mappings are being Generated..."));

      const res = await makeApiCall(
        {
          url: "/policy/excel-mapping-for-project",
          method: "POST",
        },
        undefined,
        {
          excel_headers: [data],
        }
      );

      const finalDocument: any = res.data.data;

      dispatch(
        showMessage({
          type: "success",
          message: "Mappings Generated successfully",
          displayAs: "snackbar",
        })
      );
      onCallback(true, finalDocument);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(closeLoaderWithMessage());
    }
  };

export const upsertAIProjectDocument =
  (
    data: ITempProject,
    onCallback: (isSuccess: boolean, data?: IAIProjectDocument) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { create_ts, insert_ts, ...rest } = data;
      const payload = {
        ...rest,
        file_type: rest.file_type === "EXCEL" ? "XLSX" : rest.file_type,
      };
      const res = await api.post("/policy/edit-project", payload);

      onCallback(true, res.data.data);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

//     export const extractProductsFromExcelFileAsync =
//   (
//     payload: {
//       reconciliation_template_code: string;
//       reconciliation_template_name: string;
//       reconciliation_document_code: string;

//       file_type: string;
//       template_mapping_data: any;
//       status: "ACTIVE";
//       start_row?: number;
//       end_row?: number;
//     },
//     commissionData: {
//       commission_paid: string;
//       payment_paid_date: string;
//     },
//     onCallback: (
//       isSuccess: boolean,
//       data?: {
//         reconciliation_template_code: string;
//         reconciliation_document_code: string;
//       }
//     ) => void
//   ): ThunkAction<void, IStoreState, {}, AnyAction> =>
//   async (dispatch, getState) => {
//     try {
//       const {
//         reconciliation_template_code,
//         reconciliation_document_code,
//         start_row,
//         end_row,
//       } = payload;

//       dispatch(saveLoaderProgress());
//       const res = await api.post(
//         "/accounting/edit-account-reconciliation-template",
//         reconciliation_template_code
//           ? {
//               reconciliation_document_code,
//               reconciliation_template_code,
//               start_row: start_row,
//               end_row: end_row,
//               data_for_transaction_items: {
//                 commission_paid: commissionData.commission_paid,
//                 payment_paid_date: commissionData.payment_paid_date,
//               },
//             }
//           : {
//               ...payload,
//               data_for_transaction_items: {
//                 commission_paid: commissionData.commission_paid,
//                 payment_paid_date: commissionData.payment_paid_date,
//               },
//             }
//       );
//       dispatch(
//         showMessage({
//           type: "success",
//           message: "Data Fetched successfully!",
//           displayAs: "snackbar",
//         })
//       );
//       onCallback(true, res.data.data);
//     } catch (err: any) {
//       onCallback(false);
//       dispatch(
//         showMessage({
//           type: "error",
//           message: err.response.data.message,
//           displayAs: "snackbar",
//         })
//       );
//     } finally {
//       dispatch(saveLoaderCompleted());
//     }
//   };

export const FETCH_PROJECT_DETAILS_PROGRESS = "FETCH_PROJECT_DETAILS_PROGRESS";
export const FETCH_PROJECT_DETAILS_SUCCESS = "FETCH_PROJECT_DETAILS_SUCCESS";
export const FETCH_PROJECT_DETAILS_FAILED = "FETCH_PROJECT_DETAILS_FAILED";

export const fetchProjectDetailsProgress = () =>
  action(FETCH_PROJECT_DETAILS_PROGRESS);
export const fetchProjectDetailsSuccess = (data: IProject) =>
  action(FETCH_PROJECT_DETAILS_SUCCESS, {
    data,
  });
export const fetchProjectDetailsFailed = (error: string) =>
  action(FETCH_PROJECT_DETAILS_FAILED, { error });

export const fetchProjectDetailsAsync =
  (projectCode: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchProjectDetailsProgress());

      const res = await api.post("/policy/edit-project-details", {
        project_code: projectCode,
      });

      const finalDocument: IProject = res.data.data.project_details_result;
      dispatch(fetchProjectDetailsSuccess(finalDocument));
    } catch (err: any) {
      dispatch(fetchProjectDetailsFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_PROJECT_SUMMARY_LIST_PROGRESS =
  "FETCH_PROJECT_SUMMARY_LIST_PROGRESS";
export const FETCH_PROJECT_SUMMARY_LIST_SUCCESS =
  "FETCH_PROJECT_SUMMARY_LIST_SUCCESS";
export const FETCH_PROJECT_SUMMARY_LIST_FAILURE =
  "FETCH_PROJECT_SUMMARY_LIST_FAILURE";

export const fetchProjectSummaryListProgress = () =>
  action(FETCH_PROJECT_SUMMARY_LIST_PROGRESS);

export const fetchProjectSummaryListSuccess = (
  data: IProjectSummary[],
  totalRecords: number
) => action(FETCH_PROJECT_SUMMARY_LIST_SUCCESS, { data, totalRecords });

export const fetchProjectSummaryListFailed = (errorMessage: string) =>
  action(FETCH_PROJECT_SUMMARY_LIST_FAILURE, { errorMessage });

export const fetchProjectSummaryListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    projectCode?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchProjectSummaryListProgress());
      let finalUrl = `/policy/get-project-summary?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      if (projectCode) {
        finalUrl += `&project_code=${projectCode}`;
      }

      const res = await api.get(finalUrl);
      const data: IProjectSummary[] = res.data.data;
      dispatch(fetchProjectSummaryListSuccess(data, res.data.totalRecords));
    } catch (err: any) {
      dispatch(fetchProjectSummaryListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchProjectSummaryListForDetailsAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchValue: IDatatableV2AdvancedSearchFilter,

    projectCode?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchProjectSummaryListProgress());
      let finalUrl = `/policy/get-project-summary?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;
      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }

      if (projectCode) {
        finalUrl += `&project_code=${projectCode}`;
      }

      const res = await api.get(finalUrl);
      const data: IProjectSummary[] = res.data.data;
      dispatch(fetchProjectSummaryListSuccess(data, res.data.totalRecords));
    } catch (err: any) {
      dispatch(fetchProjectSummaryListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertProjectDetailsStatus =
  (
    data: IProjectSummary,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/policy/edit-project-summary", {
        ...data,
      });
      const message = "Status saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_TEMP_PROJECT_LIST_PROGRESS =
  "FETCH_TEMP_PROJECT_LIST_PROGRESS";
export const FETCH_TEMP_PROJECT_LIST_SUCCESS =
  "FETCH_TEMP_PROJECT_LIST_SUCCESS";
export const FETCH_TEMP_PROJECT_LIST_FAILURE =
  "FETCH_TEMP_PROJECT_LIST_FAILURE";

export const fetchTempProjectListProgress = () =>
  action(FETCH_TEMP_PROJECT_LIST_PROGRESS);

export const fetchTempProjectListSuccess = (
  data: ITempProject[],
  totalRecords: number
) => action(FETCH_TEMP_PROJECT_LIST_SUCCESS, { data, totalRecords });

export const fetchTempProjectListFailed = (errorMessage: string) =>
  action(FETCH_TEMP_PROJECT_LIST_FAILURE, { errorMessage });

export const fetchTempProjectListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    projectCode?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchTempProjectListProgress());
      let finalUrl = `/policy/get-temp-project?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      if (projectCode) {
        finalUrl += `&project_code=${projectCode}`;
      }

      const res = await api.get(finalUrl);
      const data: ITempProject[] = res.data.data;
      dispatch(fetchTempProjectListSuccess(data, res.data.totalRecords));
    } catch (err: any) {
      dispatch(fetchTempProjectListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_TEMP_PROJECT_PROGRESS = "FETCH_TEMP_PROJECT_PROGRESS";
export const FETCH_TEMP_PROJECT_SUCCESS = "FETCH_TEMP_PROJECT_SUCCESS";
export const FETCH_TEMP_PROJECT_FAILURE = "FETCH_TEMP_PROJECT_FAILURE";

export const fetchTempProjectProgress = () =>
  action(FETCH_TEMP_PROJECT_PROGRESS);

export const fetchTempProjectSuccess = (data: ITempProject) =>
  action(FETCH_TEMP_PROJECT_SUCCESS, { data });

export const fetchTempProjectFailed = (errorMessage: string) =>
  action(FETCH_TEMP_PROJECT_FAILURE, { errorMessage });

export const fetchTempProjectAsync =
  (projectCode: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchTempProjectProgress());
      const finalUrl = `/policy/get-temp-project?project_code=${projectCode}`;

      const res = await api.get(finalUrl);
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchTempProjectSuccess(data[0]));
      } else {
        dispatch(fetchTempProjectFailed("No data found"));
      }
    } catch (err: any) {
      dispatch(fetchTempProjectFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_PROJECTS_STATE = "CLEAR_PROJECTS_STATE";
export const clearProjectsState = () => action(CLEAR_PROJECTS_STATE);

export const CLEAR_TEMP_PROJECT = "CLEAR_TEMP_PROJECT";
export const clearTempProject = () => action(CLEAR_TEMP_PROJECT);
